<template>
  <div>
    <v-container>
      <v-card>
        <v-card-title>
          <div class="w-100 d-flex flex-row justify-content-between">
            <div>درخواست حق اشتراک</div>

            <v-spacer></v-spacer>

            <v-btn @click="closeForm()" color=" error" icon>
              <v-icon>mdi mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-divider> </v-divider>
        <v-card-text>
          <subscription-form @closeForm="closeForm()"></subscription-form>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import SubscriptionForm from '../components/SubscriptionForm.vue';
export default {
  components: {
    SubscriptionForm,
  },
  methods: {
    closeForm() {
      this.$router.push({ path: `/financial-management/subscription` });
    },
  },
};
</script>

<style lang="scss" scoped></style>
